export default __webpack_public_path__ + "static/media/back-btn.419e1279.svg";